export default __webpack_public_path__ + "static/media/RemoveIconHover.493ff657.svg";